(function() { module.exports = this["wp"]["serverSideRender"]; }());